import script from "./LzShowMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./LzShowMore.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__